/* eslint-disable no-param-reassign */
import get from 'lodash/get'
import { Settings } from '../schema/types.ts'

// These shouldn't be changing since neither the tooltip nor the viz is resized with the window.
const TIP_HEIGHT_DEFAULT = 202
const TIP_OVERFLOW_OFFSET = 20
const TIP_FOUL_OFFSET = 34
const TIP_IN_PLAY_OFFSET = 63
const VIZ_RIGHT_EDGE = 650

export default function Tooltip(
    event: React.MouseEvent,
    settings: Settings,
    tipElement: SVGGElement,
    tipData: string | null = null
) {
    if (!tipData) {
        tipElement.innerHTML = ''
        return
    }

    let x
    let y
    const eventData = get(event, 'currentTarget.cx')

    const target = event.currentTarget as SVGCircleElement

    if (eventData) {
        x = target.cx.baseVal.value + 5
        y = target.cy.baseVal.value
    } else {
        x = target.transform.baseVal[0].matrix.e
        y = target.transform.baseVal[0].matrix.f
    }

    let tipHeight = TIP_HEIGHT_DEFAULT
    const width = settings.vizWidth / 2 + 10
    const tipWidth = width

    // TODO: Why wasn't this necessary in the current PR?
    if (tipData.includes('Foul') && tipData.includes('Exit Velocity')) {
        // Vertical tooltip offset for foul balls (with EV/LA lines)
        tipHeight += TIP_FOUL_OFFSET
    } else if (tipData.includes('(Blocked)')) {
        // Offset for Swinging Strike (Blocked) wrapping to new line
        tipHeight += TIP_OVERFLOW_OFFSET
    } else if (tipData.includes('Contact Type:')) {
        // Offset for in-play balls introducing exit velo, contact type lines
        tipHeight += TIP_IN_PLAY_OFFSET
        if (!tipData.includes('Exit Velocity')) {
            // Offset for in-play balls that do not have EV/LA data
            tipHeight -= TIP_FOUL_OFFSET
        }
        if (tipData.includes('Double Play')) {
            tipHeight += TIP_OVERFLOW_OFFSET
        }
    }

    if (y + tipHeight > settings.vizHeight) {
        y -= tipHeight
    }
    const xOffset = 10
    if (x + tipWidth > VIZ_RIGHT_EDGE) {
        x -= width + xOffset
    } else {
        x += xOffset
    }

    tipElement.innerHTML = `
        <foreignObject x=${x} y=${y} width=${width} height=${settings.vizHeight}>
                <div class="evp-svg-tooltip">
                ${tipData}
                </div>
        </foreignObject>
        `
}
